import { render, staticRenderFns } from "./VerificationCodeModal.vue?vue&type=template&id=18e47678&scoped=true&"
import script from "./VerificationCodeModal.vue?vue&type=script&lang=js&"
export * from "./VerificationCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e47678",
  null
  
)

export default component.exports